<template>

  <b-navbar
    toggleable="md"
    type="dark"
    variant="primary"
  >

    <b-navbar-brand>
      <router-link
        :to="{name: 'home'}"
        title="AEqua Roma - Torna alla pagina principale"
      >
        <span class="navbar-brand">
          <img
            src="../assets/images/logo.png"
            alt="AEqua Roma"
            style="height:2rem;"
          >
        </span>
      </router-link>
    </b-navbar-brand>

    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

    <b-collapse
      is-nav
      id="nav_collapse"
    >

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">

        <b-nav-form>
          <router-link
            :to="{name: 'landing', params: { delega: 'attiva' }}"
            class="text-white no-underline"
            v-if="$store.state.auth.user.codiceUtente != 'intermediario' 
            && $store.state.auth.user.userInc 
            && $store.state.auth.user.userInc.codiceUtente === 'intermediario' 
            && $store.state.auth.user.isCafSession != true"
          >
            <button
              class="btn btn-primary"
              title="Torna alla landing page INCARICATI"
            >
              Incaricato ({{ $store.state.auth.user.userInc.codiceFiscale }} - RU: {{$store.state.auth.user.codiceUtente}})
              <font-awesome-icon
                icon="user-circle"
                size="lg"
              />
            </button>
          </router-link>

          <router-link
            :to="{name: 'selettoreCaf', params: { delega: 'attiva' }}"
            class="text-white no-underline"
            v-if="$store.state.auth.user.codiceUtente != 'intermediario' &&
                    this.$store.state.auth.user && 
                    this.$store.state.auth.user.userInc && 
                    this.$store.state.auth.user.isCafSession"
          >
            <button
              class="btn btn-primary"
              title="Torna alla Caf Dashboard"
            >
              Delegato ({{ $store.state.auth.user.userInc.codiceFiscale }} - RU: {{$store.state.auth.user.codiceUtente}})
              <font-awesome-icon
                icon="user-circle"
                size="lg"
              />
            </button>
          </router-link>

          <router-link
            :to="{name:'messages'}"
            class="text-white no-underline"
            v-if="$store.state.auth.user.codiceUtente != 'intermediario' 
            && !$store.state.auth.user.isCafSession"
          >
            <button
              class="btn btn-primary"
              title="Comunicazioni dal portale del patrimonio"
            >
              <font-awesome-icon
                icon="envelope"
                :size="open > 0 ? 'lg' : 'sm'"
              />
              <b-badge
                v-if="open > 0"
                variant="warning"
                pill
              >{{open}}</b-badge>
              <b-badge
                v-else
                variant="primary"
                pill
              >{{open}}</b-badge>
            </button>
          </router-link>

          <router-link
            v-if="$store.state.auth.user.codiceUtente != 'intermediario' &&
            !$store.state.auth.user.isCafSession"
            :to="{name: 'home'}"
            class="text-white no-underline"
          >
            <button
              class="btn btn-primary"
              title="Torna alla pagina principale"
            >
              <font-awesome-icon
                icon="home"
                size="lg"
              />
            </button>
          </router-link>

          <router-link
            :to="{name:'aiuto'}"
            class="text-white no-underline"
          >
            <button
              class="btn btn-primary"
              title="Aiuto"
            >
              <font-awesome-icon
                icon="question-circle"
                size="lg"
              />
            </button>
          </router-link>

          <b-dropdown
            v-if="$store.getters.isAuthenticated"
            variant="primary"
            class="m-md-2"
          >
            <template slot="button-content">
              <font-awesome-icon
                icon="user-circle"
                size="lg"
                class="mr-2"
              /> {{ $store.state.auth.user.nome }} {{ $store.state.auth.user.cognome }}
            </template>
            <b-dropdown-item
              xxxv-if="$store.state.auth.user.logonMode === 'local'"
              v-if="$store.state.auth.user.logonMode === $store.state.auth.autentication.standard"
              @click="modificaPassword"
            >
              <font-awesome-icon
                icon="key"
                size="lg"
                class="text-success mr-2"
              />Modifica password
            </b-dropdown-item>
            <b-dropdown-item
              xxxv-if="$store.state.auth.user.logonMode === 'local'"
              v-if="$store.state.auth.user.logonMode === $store.state.auth.autentication.standard"
              @click="modificaMobile"
            >
              <font-awesome-icon
                icon="mobile-alt"
                size="lg"
                class="text-success mr-2"
              />Modifica numero mobile
            </b-dropdown-item>
            <b-dropdown-divider />
            <b-dropdown-item @click="logout">
              <font-awesome-icon
                icon="sign-out-alt"
                size="lg"
                class="text-danger mr-2"
              />Esci
            </b-dropdown-item>
          </b-dropdown>
        </b-nav-form>

      </b-navbar-nav>

    </b-collapse>
  </b-navbar>

  <!--
  <nav class="navbar fixed-top navbar-expand navbar-dark bg-primary">
    <router-link
      :to="{name: 'home'}"
      title="AEqua Roma - Torna alla pagina principale"
    >
      <span class="navbar-brand">
        <img
          src="../assets/images/logo.png"
          alt="AEqua Roma"
          style="height:2rem;"
        >
      </span>
    </router-link>

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="hidden-xs-down">
      <ul class="navbar-nav mr-auto" />
      <form class="form-inline">
        <router-link :to="{name: 'home'}" class="text-white no-underline">
          <button class="btn btn-primary" title="Torna alla pagina principale">
            <font-awesome-icon icon="home" size="lg" />
          </button>
        </router-link>

        <router-link
          :to="{name:'aiuto'}"
          class="text-white no-underline"
        >
          <button class="btn btn-primary" title="Aiuto">
            <font-awesome-icon icon="question-circle" size="lg"/>
          </button>
        </router-link>

        <b-dropdown
          v-if="$store.getters.isAuthenticated"
          variant="primary"
          class="m-md-2"
        >
          <template slot="button-content">
            <font-awesome-icon icon="user-circle" size="lg" class="mr-2"
            /> {{ $store.state.auth.user.nome }} {{ $store.state.auth.user.cognome }}
          </template>
          <b-dropdown-item @click="modificaPassword">
            <font-awesome-icon icon="key" size="lg" class="text-success mr-2"/>Modifica password
          </b-dropdown-item>
          <b-dropdown-item @click="modificaMobile">
            <font-awesome-icon icon="mobile-alt" size="lg" class="text-success mr-2"/>Modifica numero mobile
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item @click="logout">
            <font-awesome-icon icon="sign-out-alt" size="lg" class="text-danger mr-2"/>Esci
          </b-dropdown-item>
        </b-dropdown>
      </form>
    </div>
  </nav>
 -->
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Navbar',
  computed: {
    ...mapGetters('messages', ['open'])
  },
  async created () {
    await this.load()
  },
  methods: {
    async load () {
      await this.$store.dispatch('messages/countOpen')
    },
    modificaPassword () {
      // try {
      //  await this.$store.dispatch('logout')
      // } catch (err) {}

      this.$router.push({ name: 'changePassword' })
    },
    modificaMobile () {
      this.$router.push({ name: 'cambiaMobileUtente' })
    },
    async logout () {
      try {
        await this.$store.dispatch('logout')
      } catch (err) { }
      // this.$router.push({ name: 'login' })
      this.$router.push({ path: '/entrata' })
    },
    async tornaCafDashboard() {
      try {
        //redirect alla home
        await this.$router.push({ name: 'selettoreCaf' })
      } catch (err) {
        console.error('Errore nel ripristino utente CAF:', err)
        this.$ui.showError(err)
      } 
    }
  }
}
</script>
